import { createElement, useState, useEffect, useRef, memo } from '@max/max';
import LImage from '@max/leez-image';
import View from '@hfe/max-view';
import { Vap } from '@lingbo/effects/extend/alphaVideo';
import './index.scss';
import { getFullScreenSize } from '@/utils/layout';
const WebVapView = (props) => {
    const { mtapConfigJson, mp4, loop = true, width, height, keepLastFrame, widthHeightRatio, widthInRpx, autoPlay = true } = props;
    const animRef = useRef(null);
    const bgImgRef = useRef(null);
    const [vapFail, setVapFail] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const { width: widthInPx, toRateSize } = getFullScreenSize();
    const fallbackTimer = useRef(null);
    const vap = useRef(null);
    const timers = useRef([]);
    const prevConfig = useRef({
        mtapConfigJson: props.mtapConfigJson,
        mp4: props.mp4
    });
    function clearTimers() {
        timers.current.forEach(t => clearTimeout(t));
    }
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        try {
            if (vap.current) {
                (_a = vap.current) === null || _a === void 0 ? void 0 : _a.destory();
                vap.current = null;
                if (fallbackTimer.current)
                    clearTimeout(fallbackTimer.current);
            }
            const canvasWidth = widthInRpx ? toRateSize(widthInRpx) : widthInPx;
            if (animRef.current) {
                vap.current = new Vap({
                    container: animRef.current,
                    src: mp4,
                    vapOptions: mtapConfigJson,
                    loop,
                    keepLastFrame,
                    autoPlay,
                    isAudio: false,
                    isVideo: false
                }, widthHeightRatio ? {
                    width: canvasWidth,
                    height: canvasWidth / widthHeightRatio,
                    pixel: (window === null || window === void 0 ? void 0 : window.devicePixelRatio) || 10
                } : undefined);
            }
            (_b = vap.current) === null || _b === void 0 ? void 0 : _b.on('loaded', () => {
                var _a;
                setLoaded(true);
                vap.current.play();
                (_a = props.onStart) === null || _a === void 0 ? void 0 : _a.call(props);
                if (props.playPointActions) {
                    props.playPointActions.forEach(({ microseconds, action }) => {
                        const t = setTimeout(() => {
                            action();
                        }, microseconds);
                        timers.current.push(t);
                    });
                }
            });
            (_c = vap.current) === null || _c === void 0 ? void 0 : _c.on('end', () => {
                var _a;
                (_a = props.onVideoEnd) === null || _a === void 0 ? void 0 : _a.call(props);
            });
        }
        catch (e) {
            (_d = vap.current) === null || _d === void 0 ? void 0 : _d.destory();
            setVapFail(true);
            (_e = props.onFallback) === null || _e === void 0 ? void 0 : _e.call(props);
            clearTimers();
        }
        return () => {
            var _a;
            (_a = vap.current) === null || _a === void 0 ? void 0 : _a.destory();
            clearTimers();
            setVapFail(true);
        };
    }, []);
    useEffect(() => {
        var _a, _b;
        if (((_a = prevConfig.current) === null || _a === void 0 ? void 0 : _a.mtapConfigJson) === props.mtapConfigJson && prevConfig.current.mp4 === props.mp4) {
            return;
        }
        prevConfig.current = {
            mtapConfigJson: props.mtapConfigJson,
            mp4: props.mp4
        };
        (_b = vap.current) === null || _b === void 0 ? void 0 : _b.updateVideo({
            src: props.mp4,
            vapOptions: props.mtapConfigJson,
            loop: props.loop
        });
    }, [props.mtapConfigJson, props.mp4]);
    return <>
      {props.cover && (vapFail || !loaded) ? <View ref={bgImgRef}>
            <LImage className='vapImageFilter' widthHeightRatio={props.widthHeightRatio} style={Object.assign({ width,
        height }, props.style)} source={{
        uri: props.cover
    }} resizeMode='cover'/>
          </View> : null}
      <View className='vapContainer' style={Object.assign(Object.assign({ width,
        height }, props.style), { pointerEvents: 'none' })} ref={animRef}/>
    </>;
};
export default memo(WebVapView);
